import React from 'react';
import PropTypes from 'prop-types';
import { PersonIcon } from '../Icon';
import SmallLabel from '../SmallLabel';

const AuthorLabel = ({ name, ...other }) => (
  <SmallLabel {...other}>
    <PersonIcon />
    {name}
  </SmallLabel>
);
AuthorLabel.propTypes = {
  name: PropTypes.string,
};
AuthorLabel.defaultProps = {
  name: '',
};

export default AuthorLabel;
